import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { localCurrency } from "@/plugins/currency";
import { Action, Getter } from "vuex-class";

// External components
import ModalBase from "../modalBase/modalBase";
import QuantityButton from "@/components/quantityButton/quantityButton";
import EditMenuQuantityCard from "../editMenuQuantityCard/editMenuQuantityCard";

import { getMenuPriceByMenuId } from "@/plugins/subscriptions_helper";

@Component({
  components: {
    QuantityButton,
    ModalBase,
    EditMenuQuantityCard,
  },
  methods: {
    getMenuPriceByMenuId,
  },
})
export default class EditDishModal extends Vue {
  @Prop({ default: false }) isActive;

  @Getter getSubscription;
  @Getter getCity;
  @Getter getMenus;
  @Getter getMenuPrices;

  @Action action_updateSubscription;
  @Action action_getMenus;
  @Action action_getMenuPrices;

  isLoading = false;
  detailsSubscriptionMenus = [];
  personQuantity = null;

  get getSubtotal() {
    let response = 0;
    this.detailsSubscriptionMenus.forEach((menu) => {
      response +=
        menu.count *
        getMenuPriceByMenuId(menu.menu_id, this.getMenuPrices, this.detailsSubscriptionMenus);
    });
    return response * this.personQuantity;
  }

  get getDeliveryCost() {
    let response = 0;
    const { free_delivery_amount } = this.getCity;
    if (this.getSubtotal < parseInt(free_delivery_amount)) {
      const { variables } = this.getCity;
      if (variables[0]) response = parseInt(variables[0].value);
    }
    return response;
  }

  get getTotal() {
    return this.getSubtotal + this.getDeliveryCost;
  }

  get freeDeliveryPercentageWidth() {
    const freeDeliveryAmount = parseInt(this.getCity.free_delivery_amount);
    if (this.getSubtotal < freeDeliveryAmount) {
      return (this.getSubtotal / freeDeliveryAmount) * 100;
    }
    return 100;
  }

  async mounted() {
    this.isLoading = true;
    if (!this.getMenus) {
      await this.action_getMenus({ commerceId: this.getCity.id });
    }
    if (!this.getMenuPrices) {
      await this.action_getMenuPrices();
    }
    this.isLoading = false;
    this.setInitialValues();
  }

  @Watch("isActive")
  setInitialValues() {
    this.detailsSubscriptionMenus = JSON.parse(
      JSON.stringify(this.getSubscription.details_subscription_menus)
    );
    this.personQuantity = this.getSubscription.person_quantity;
    this.fillSubscriptionMissingMenus();
  }

  fillSubscriptionMissingMenus() {
    this.getMenus.forEach((menu) => {
      const { id, name } = menu;
      const findIndex = this.detailsSubscriptionMenus.findIndex(
        (subscriptionMenu) => id === subscriptionMenu.menu_id
      );
      if (findIndex < 0) {
        this.detailsSubscriptionMenus.push({
          count: 0,
          day: [],
          menu_id: id,
          menu_name: name,
          price: 0,
        });
      }
    });
  }

  changePersonQuantity(newQuantity) {
    this.personQuantity = newQuantity;
  }

  changeMenuQuantity(value: any) {
    const { menu_id, count } = value;
    const findMenu = this.detailsSubscriptionMenus.find((menu) => menu.menu_id === menu_id);
    if (findMenu) findMenu.count = count;
  }

  async updateSubscription() {
    this.isLoading = true;
    const subscriptionDetails = this.detailsSubscriptionMenus.map((menu) => {
      return { menu_id: menu.menu_id, count: menu.count };
    });
    try {
      await this.action_updateSubscription({
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: { details: subscriptionDetails, person_quantity: this.personQuantity },
        },
      });
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al actualizar la suscripción. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }

    this.isLoading = false;
    this.$emit("modal-close");
  }

  getSubscriptionMenuByMenuId(menuId) {
    return this.detailsSubscriptionMenus.find((menu) => menu.menu_id === menuId) || 0;
  }

  getMenuById(menuId) {
    return this.getMenus.find((menu) => menu.id === menuId);
  }

  toLocalCurrency(value) {
    return localCurrency(value);
  }
}
